var popup = document.getElementById("contact-popup");

if( popup ) {

    var popupClose = document.querySelector(".popup-close");

    var closePopup = function() {
        if( popup ) {
            popup.classList.add('hidden');
            setTimeout(function() {
                popup.parentNode.removeChild(popup);
                popup = null;
                setCookie( "hide_glaifa_popup", 1, 3 ); // 3 days
            }, 400);
        }
    }

    popup.addEventListener("click", function(e) {
        if ( e.target !== popup ) return;
        closePopup();
    }, false);

    popupClose.addEventListener("click", function(e) {
        closePopup();
    }, false);

    document.onkeydown = function(evt) {
        evt = evt || window.event;
        if (evt.keyCode == 27) {
            closePopup();
        }
    };

    if( popup.classList.contains('contact-popup--init') ) {
        setTimeout(function() {
            popup.classList.remove('contact-popup--init');
        }, 10000);
    }

}

function setCookie( name, value, days ) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie( name ) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function eraseCookie( name ) {   
    document.cookie = name+'=; Max-Age=-99999999;';  
}
